<script>
  import api from "$/client/api.js";
  import { base_host } from "$/client/config.js";
  export let product_id;
  export let price;
  export let preorder;
  export let active;
  export let external_links;
  export let discount;
  export let original_price;
  let error = undefined;

  const add_to_cart = async () => {
    // have to use OG base host to make sure it points at the public URL
    const [status, data] = await api.post(`${base_host}/api/cart`, { product_id });
    if(status === 200) {
      // have to do it this way so it works in rendered pages Hydrated
      window.location = "/client/#/cart/";
    } else if(status === 500) {
      error = "Major server failure, please email help@learncodethehardway.com to report it.";
    } else {
      console.log("Error!", status, data);
    }
  }
</script>

<style>

  button {
    display: flex;
    padding-left: 2rem;
    padding-right: 2rem;
    padding-top: 1rem;
    padding-bottom: 1rem;
    color: var(--value9) !important;
    border-radius: 30px;
    text-decoration: none;
    justify-content: center;
    background-color: var(--purple);
    text-align: center;
  }

  button:hover {
    transition: 0.2s;
    background-color: var(--dark-purple);
    box-shadow: var(--dark-shadow);
    color: var(--value9) !important;
  }
</style>

{#if active}
  {#if error }
    <toast>{ error }</toast>
  {:else}
    <div style="display: flex; flex-direction: column; gap: 0.5rem;">
      <button type="button" data-testid="purchase-button" on:click={ add_to_cart }>
        <span>
        {#if price == 0}
          Register for Free
        {:else if preorder}
          Pre-Order Digital+Videos for 
          {#if discount > 0}
            <br/><span class="strikethrough-diagonal">${original_price} USD</span> now ${ price } @ { discount }% off!
          {:else}
            ${ price } USD
          {/if}
        {:else}
          Purchase Digital+Videos for <br/>${ price } USD
          {#if discount > 0}
            <span class="strikethrough-diagonal">${original_price} USD</span> now ${ price } @ { discount }% off!
          {:else}
            ${ price } USD
          {/if}
        {/if}
        </span>
      </button>

      {#if price != 0 && external_links}
        {#each JSON.parse(external_links) as link}
          <button>
            <a target="_blank" style="" href={link.url} data-testid="purchase-paper-button">
              Buy {link.what} from {link.name}
            </a>
          </button>
        {/each}
      {/if}
    </div>
  {/if}
{/if}
